$(document).ready(function() {
    // Prevent scrolling during intro animation
    $('body').css('overflow', 'hidden');
    
                initializeMainSlider();
    // Logo animation sequence
    setTimeout(function() {
        // Start fading out the intro screen after logo animation
        $('#intro-screen').addClass('fade-out');
        
        // Show background image and main slider
        setTimeout(function() {
            $('.background-container').addClass('show');
            $('#main-slider').addClass('show');
            
            // Initialize main vertical slider after showing
            setTimeout(function() {
                
                // Disable body scrolling since we use vertical slider
                $('body').css('overflow', 'hidden');
                
                // Keep intro screen in DOM but hidden
                // $('#intro-screen').remove(); // Commented out - don't remove intro screen
            }, 1000);
            
        }, 500);
        
    }, 2000); // Wait for logo animation to complete (2s) + 1s delay
    
    // Smooth scroll behavior for any anchor links
    $('a[href*="#"]').on('click', function(e) {
        e.preventDefault();
        
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 500, 'linear');
    });
    
    $('.openlookbook').on('click', function(e) {
        e.preventDefault();
        const $slide = $('.lookbook-slide');
        $slide.addClass('visible');
        setTimeout(() => $slide.addClass('fade-in'), 10);
    });

    $('.lookbook-logo').on('click', function(e) {
        e.preventDefault();
        const $slide = $('.lookbook-slide');
        if ($(this).hasClass('w0-floating-lookbook-logo') || $(this).closest('.is-home-lookbook').length) {
            if (window.mainSwiperInstance) {
                window.mainSwiperInstance.slideNext();
            }
            return;
        }
        $slide.removeClass('fade-in');
        setTimeout(() => $slide.removeClass('visible'), 500);
    });

    // Optional: Add scroll-based animations for content sections
    $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        
        $('.content-section').each(function() {
            var elementTop = $(this).offset().top;
            var elementHeight = $(this).height();
            
            // Check if element is in viewport
            if (scrollTop + windowHeight > elementTop + 100) {
                $(this).addClass('animate-in');
            }
        });
    });
    
    // Add CSS class for scroll animations
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            .content-section {
                opacity: 0.8;
                transform: translateY(20px);
                transition: all 0.6s ease-out;
            }
            
            .content-section.animate-in {
                opacity: 1;
                transform: translateY(0);
            }
        `)
        .appendTo('head');
    
    // Handle window resize for responsive behavior
    $(window).on('resize', function() {
        // Recalculate any position-dependent elements if needed
        // Background image container is always fixed positioned
        $('.background-container').css('position', 'fixed');
    });
    
    // Trigger resize event on load to set initial state
    $(window).trigger('resize');
    
    // Monitor background image loading
    var $backgroundImg = $('#background-image');
    var loadingComplete = false;
    
    // Check if image is already loaded (cached)
    if ($backgroundImg[0].complete) {
        loadingComplete = true;
    } else {
        // Wait for image to load
        $backgroundImg.on('load', function() {
            loadingComplete = true;
        });
        
        $backgroundImg.on('error', function() {
            loadingComplete = true;
        });
        
        // Fallback timeout for image loading
        setTimeout(function() {
            if (!loadingComplete) {
                loadingComplete = true;
            }
        }, 5000);
    }
    
});

// === Viewport helpers (fix mobile offset using visualViewport when available) ===
function getViewportHeight() {
    if (window.visualViewport && window.visualViewport.height) {
        return Math.round(window.visualViewport.height);
    }
    return Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
}

function setSliderHeight() {
    const h = getViewportHeight();
    const targets = [
        '.main-slider',
        '.main-swiper',
        '.main-swiper .swiper-wrapper',
        '.main-swiper .swiper-slide'
    ];
    targets.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            try { el.style.setProperty('height', '100vh', 'important'); } catch(e) {}
        });
    });
     if (window.mainSwiperInstance) {
        window.mainSwiperInstance.update();
        window.mainSwiperInstance.updateSlides();
        window.mainSwiperInstance.updateProgress();
    }
}

function updateSwiper() {
    if (!window.mainSwiperInstance) return;
    requestAnimationFrame(() => {
        try { window.mainSwiperInstance.updateSlides(); } catch(e) {}
        try { window.mainSwiperInstance.update(); } catch(e) {}
    });
}

function handleViewportChange() {
    setSliderHeight();
    updateSwiper();
    updateHomeLookbookLogoAnimation(window.mainSwiperInstance);
}

function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

const homeLookbookLogoState = {
    current: null,
    target: null,
    raf: null,
};

function setupHomeLookbookLogoAnimation(swiper) {
    const logo = document.querySelector('.w0-scroll-logo');
    if (!logo) return;

    const logoWrap = logo.closest('.lookbook-logo');
    if (!logoWrap) return;

    if (!logoWrap.classList.contains('w0-floating-lookbook-logo')) {
        document.body.appendChild(logoWrap);
        logoWrap.classList.add('w0-floating-lookbook-logo');
    }

    updateHomeLookbookLogoAnimation(swiper || window.mainSwiperInstance, true);
}

function getHomeLookbookLogoTarget(swiper) {
    const firstLookbookSlide = document.querySelector('.lookbook-slide.is-home-lookbook')?.closest('.main-swiper .swiper-slide');
    const slides = Array.from(swiper.slides || []);
    const lookbookIndex = firstLookbookSlide ? slides.indexOf(firstLookbookSlide) : 0;
    const slideHeight = swiper.height || getViewportHeight() || 1;
    const virtualIndex = Math.max(0, -swiper.translate / slideHeight);
    const progress = Math.min(Math.max(virtualIndex - Math.max(lookbookIndex, 0), 0), 1);
    const eased = easeInOutQuad(progress);
    const headerHeight = document.querySelector('.section-header')?.offsetHeight || 64;
    const startY = getViewportHeight() / 2;
    const endY = headerHeight / 2;
    const startScale = 1;
    const endScale = window.innerWidth <= 768 ? 0.34 : 0.18;
    const currentY = startY + (endY - startY) * eased;
    const currentScale = startScale + (endScale - startScale) * eased;
    const shadowStrength = 0;

    return {
        y: currentY,
        scale: currentScale,
        blur: 0,
        alpha: 0,
        docked: progress > 0.96,
    };
}

function applyHomeLookbookLogoState(logoWrap, state) {
    logoWrap.style.top = `${state.y}px`;
    logoWrap.style.transform = `translate(-50%, -50%) scale(${state.scale})`;
    logoWrap.style.filter = 'none';
    document.body.classList.toggle('w0-logo-docked', state.docked);
}

function animateHomeLookbookLogo() {
    const logoWrap = document.querySelector('.w0-floating-lookbook-logo');
    const state = homeLookbookLogoState;
    if (!logoWrap || !state.current || !state.target) {
        state.raf = null;
        return;
    }

    const ease = 0.16;
    state.current.y += (state.target.y - state.current.y) * ease;
    state.current.scale += (state.target.scale - state.current.scale) * ease;
    state.current.blur += (state.target.blur - state.current.blur) * ease;
    state.current.alpha += (state.target.alpha - state.current.alpha) * ease;
    state.current.docked = state.target.docked;

    applyHomeLookbookLogoState(logoWrap, state.current);

    const isSettled =
        Math.abs(state.target.y - state.current.y) < 0.4 &&
        Math.abs(state.target.scale - state.current.scale) < 0.002 &&
        Math.abs(state.target.blur - state.current.blur) < 0.2 &&
        Math.abs(state.target.alpha - state.current.alpha) < 0.01;

    if (isSettled) {
        state.current = { ...state.target };
        applyHomeLookbookLogoState(logoWrap, state.current);
        state.raf = null;
        return;
    }

    state.raf = requestAnimationFrame(animateHomeLookbookLogo);
}

function updateHomeLookbookLogoAnimation(swiper, immediate = false) {
    const logoWrap = document.querySelector('.w0-floating-lookbook-logo');
    if (!logoWrap || !swiper) return;

    const target = getHomeLookbookLogoTarget(swiper);
    const state = homeLookbookLogoState;
    state.target = target;

    if (immediate || !state.current) {
        state.current = { ...target };
        applyHomeLookbookLogoState(logoWrap, state.current);
        return;
    }

    if (!state.raf) {
        state.raf = requestAnimationFrame(animateHomeLookbookLogo);
    }
}



// === INIT ===
document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.background-container')?.classList.add('show');
    document.getElementById('main-slider')?.classList.add('show');
    setupHomeLookbookLogoAnimation(window.mainSwiperInstance);
    setTimeout(() => {
        setSliderHeight();    
        setupHomeLookbookLogoAnimation(window.mainSwiperInstance);
    }, 300); 
});

window.addEventListener('resize', handleViewportChange, { passive: true });
window.addEventListener('orientationchange', () => setTimeout(handleViewportChange, 100));
if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleViewportChange);
    window.visualViewport.addEventListener('scroll', handleViewportChange, { passive: true });
}
function initializeMainSlider() {
    window.mainSwiperInstance = new Swiper('.main-swiper', {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        mousewheel: {
            enabled: true,
            sensitivity: 1,
            thresholdDelta: 50,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        observer: true,
        observeParents: true,
        on: {
            progress: function () {
                updateHomeLookbookLogoAnimation(this);
            },

            setTranslate: function () {
                updateHomeLookbookLogoAnimation(this);
            },

            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                const productSwipers = activeSlide.querySelectorAll('.product-swiper');

                productSwipers.forEach(function (swiperEl) {
                    if (!swiperEl.swiper) {
                        initializeProductSlider(swiperEl);
                    }
                });

                restoreExpandedCards();
            },

            slideChangeTransitionEnd: function () {
                const activeSlide = this.slides[this.activeIndex];
                const productSwipers = activeSlide.querySelectorAll('.product-swiper');

                productSwipers.forEach(swiperEl => {
                    const swiperInstance = swiperEl.swiper;
                    if (swiperInstance) {
                        const activeSlideIndex = swiperInstance.activeIndex;
                        const activeSlideEl = swiperInstance.slides[activeSlideIndex];
                        const video = activeSlideEl?.querySelector('video');
                       
                    }
                });
            },

            init: function () {
                const firstSlide = this.slides[0];
                const productSwipers = firstSlide.querySelectorAll('.product-swiper');

                productSwipers.forEach(swiperEl => {
                    if (!swiperEl.swiper) {
                        initializeProductSlider(swiperEl);
                    }
                });

                initializeProductCardInteractions();
                setSliderHeight();
                setupHomeLookbookLogoAnimation(this);
            },

            observerUpdate: function () {
                restoreExpandedCards();
                setSliderHeight();
            }
        }
    });

    document.body.addEventListener('touchmove', function (e) {
        if (!e.target.closest('.product-swiper')) {
            e.preventDefault();
        }
    }, { passive: false });

    return window.mainSwiperInstance;
}


function initializeProductCardInteractions() {
    $('.product-slider-container').off('click');
    $('.product-content').off('click');
    $('.size-btn').off('click');
    $('.product-card').off('click.w0ProductCard');

    function openProductCard($card) {
        if (!$card.length || $card.hasClass('expanded')) return;

        $('.product-card').not($card).removeClass('expanded').data('expanded', false);
        $card.addClass('expanded').data('expanded', true);
    }

    $('.product-card').on('click.w0ProductCard', function(e) {
        if ($(e.target).closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination, .size-btn, .size-options').length) {
            return;
        }

        e.stopPropagation();
        openProductCard($(this));
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.product-card').length) {
            $('.product-card').removeClass('expanded').data('expanded', false);
        }
    });

    $('.size-btn').on('click', function(e) {
        e.stopPropagation();
        var $btn = $(this);
        $btn.siblings().removeClass('active');
        $btn.addClass('active');
    });

    $('.product-content').on('click', function(e) {
        if ($(e.target).closest('.size-btn, .size-options').length) {
            e.stopPropagation();
            return;
        }

        var $card = $(this).closest('.product-card');
        if (!$card.hasClass('expanded')) return;

        var rect = this.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var clickY = e.clientY - rect.top;

        if (clickX > rect.width - 50 && clickY < 50) {
            $card.removeClass('expanded').data('expanded', false);
            e.stopPropagation();
        }
    });

    restoreExpandedCards();
}
function restoreExpandedCards() {
    $('.product-card').each(function() {
        var $card = $(this);
        if ($card.data('expanded')) {
            $card.addClass('expanded');
        } else {
            $card.removeClass('expanded');
        }
    });
}

// Initialize final slide interactions
function initializeFinalSlideInteractions() {
    // Video popup functionality
    $('.clickable-logo').on('click', function() {
        const videoSrc = $(this).data('video');
        if (videoSrc) {
            $('#popup-video source').attr('src', videoSrc);
            $('#popup-video')[0].load();
            $('#video-popup').css('display','flex');
        }
        jQuery('.rams--playing #rams-button').click()

    });
    
    // Close video popup
    $('.video-close, .video-popup').on('click', function(e) {
        if (e.target === this) {
            $('#video-popup').fadeOut(300);
            $('#popup-video')[0].pause();
        }
    });
    
    // Prevent video popup from closing when clicking on video
    $('#popup-video').on('click', function(e) {
        e.stopPropagation();
    });
    
    // Logo navigation functionality
    $('.clickable-logo-nav').on('click', function() {
        if (window.mainSwiperInstance) {
            window.mainSwiperInstance.slideNext();
        }
    });
    
    // ESC key to close video popup
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('#video-popup').fadeOut(300);
            $('#popup-video')[0].pause();
        }
    });
}

initializeFinalSlideInteractions();









  function handleSizeButtonClick(e) {
    const sizeBtn = e.currentTarget;
    const size = sizeBtn.dataset.size;
    const productCard = sizeBtn.closest('.product-card');
    const handle = productCard?.dataset.productHandle;

    if (!handle) {
      return;
    }

    window.productCache = window.productCache || {};
    let productData = window.productCache[handle];

    if (productData) {
      processVariant(productData, size, handle);
    } else {
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(data => {
          window.productCache[handle] = data;
          processVariant(data, size, handle);
        })
        .catch(err => {
        });
    }
  }
  function initializeProductSlider(swiperEl) {
	return new Swiper(swiperEl, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		pagination: {
			el: swiperEl.querySelector('.swiper-pagination'),
			clickable: true
		},
		navigation: {
			nextEl: swiperEl.querySelector('.swiper-button-next'),
			prevEl: swiperEl.querySelector('.swiper-button-prev')
		},
		effect: 'slide',
		direction: 'horizontal',
        speed: 500,	
	});
}

function pauseAllVideos(swiper) {
	swiper.slides.forEach(slide => {
		const video = slide.querySelector('video');
		if (video) {
			video.pause();
			// Опционально: сбросить время, если нужно
			// video.currentTime = 0;
		}
	});
}

function playActiveVideo(swiper) {
	const activeSlide = swiper.slides[swiper.activeIndex];
	const video = activeSlide?.querySelector('video');
	if (video) {
		video.currentTime = 0; // сбросить на начало
		const playPromise = video.play();
		if (playPromise !== undefined) {
			playPromise.catch(() => {
				// Игнорируем ошибки (например, если браузер блокирует autoplay)
			});
		}
	}
}
  function processVariant(productData, size, handle) {
        const variant = productData.variants.find(v =>
        (v.option1 === size) || (v.option2 === size) || (v.option3 === size)
        );
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';
        const cartSectionsUrl = `${window.routes?.cart_url || '/cart'}?sections=cart-drawer`;

        fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
        })
        .then(res => {
        if (!res.ok) throw new Error('Ошибка добавления');
        return fetch(cartSectionsUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        })
        .then(res => res.json())
        .then(sections => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer || !sections['cart-drawer']) return;

        cartDrawer.innerHTML = sections['cart-drawer'];

        const nested = cartDrawer.querySelector('cart-drawer');
        if (nested) {
            cartDrawer.replaceWith(nested);
            nested.open?.();
        } else {
            cartDrawer.open?.();
        }

        })
        .catch(err => {
        });
  }


  function initSizeButtons() {
    document.querySelectorAll('.size-btn').forEach(btn => {
      btn.removeEventListener('click', handleSizeButtonClick);
      btn.addEventListener('click', handleSizeButtonClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initSizeButtons, 300);
    });
  } else {
    setTimeout(initSizeButtons, 300);
  }


function fixBottomSafeArea() {
  const vh = window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${vh * 0.01}px`);
}

window.addEventListener('resize', fixBottomSafeArea);
window.addEventListener('orientationchange', fixBottomSafeArea);
fixBottomSafeArea();

function startIntroSequence() {
    const swiper = window.mainSwiperInstance;
    swiper.slideTo(0, 00);    
     setTimeout(function() {
        // Start fading out the intro screen after logo animation
        $('#intro-screen').addClass('fade-out');
        
        // Show background image and main slider
        setTimeout(function() {
            $('.background-container').addClass('show');
            $('#main-slider').addClass('show');           
            
        }, 500);
        
    }, 2000);
}

document.addEventListener('click', function(e) {
    if (!e.target.closest('.rabbit-hole, .w0-rabbit-hole-trigger')) return;
    $('.background-container').removeClass('show');
   // $('#main-slider').removeClass('show');

    $('#intro-screen').removeClass('fade-out');
    setTimeout(function() {
        startIntroSequence();
    }, 1500);
});
document.addEventListener('DOMContentLoaded', function () {
  const lookbookSlide = document.querySelector('.lookbook-slide');
  if (!lookbookSlide) {
    return;
  }

  const lookbookSwiperEl = lookbookSlide.querySelector('.lookbook-swiper');
  if (!lookbookSwiperEl) {
    return;
  }

  if (lookbookSwiperEl.swiper) {
    return;
  }



    const lookbookSwiper = new Swiper(lookbookSwiperEl, {
        effect: 'slide',
        fadeEffect: { crossFade: true },
        loop: true,
        allowTouchMove: true,
        simulateTouch: true,
        speed: 500,
        autoplay: {
            delay: 1400,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        keyboard: true,
        navigation: false,
        pagination: false,
        scrollbar: false,
    });

    const leftZone = lookbookSwiperEl.querySelector('.lookbook-nav-left');
    const rightZone = lookbookSwiperEl.querySelector('.lookbook-nav-right');
    if (leftZone && rightZone) {
    leftZone.addEventListener('click', (e) => { e.preventDefault(); lookbookSwiper.slidePrev(); });
    rightZone.addEventListener('click', (e) => { e.preventDefault(); lookbookSwiper.slideNext(); });
    }

    const mainSwiper = window.mainSwiperInstance;
    lookbookSlide.addEventListener('mouseenter', () => {
    if (mainSwiper?.mousewheel) mainSwiper.mousewheel.disable();
    });
    lookbookSlide.addEventListener('mouseleave', () => {
    if (mainSwiper?.mousewheel) mainSwiper.mousewheel.enable();
    });
});
